import React, { useEffect, useState } from "react";
import { Badge, Container, Card, Row, Col, Spinner } from "react-bootstrap";
import { BsClipboardData, BsCircleFill } from "react-icons/bs";
import { MdCastConnected, MdHttps } from "react-icons/md";
import { AiOutlinePieChart } from "react-icons/ai";
import { FaRegUser } from "react-icons/fa";
import { RiDatabase2Line } from "react-icons/ri";
import { RadialChart } from "react-vis";
import AutoSizer from "react-virtualized-auto-sizer";
import { everySeries } from "async";
import { BRAND, STATUS } from 'Utils/styleTokens';

const FormVisPanel = (props) => {
  const [data, setData] = useState([]);
  const [value, setValue] = useState(null);
  const [samplePercent, setSamplePercent] = useState(0);
  const [every, setEvery] = useState("");

  useEffect(() => {
    try {
      let percent = Math.round(props.rules.size / props.rules.every * 1000) / 10;
      let angleSampled = percent / 100 * 360;
      let angleRows = 360 - angleSampled;

      let arr = [
        { angle: angleSampled, color: STATUS.warning.dot, labelText: "Sampled Rows" },
        { angle: angleRows, color: BRAND.blue, labelText: "Total Rows" }
      ];
  
      setSamplePercent(percent);
      setData(arr);
      setEvery(props.rules.every.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    } catch(e) {
      console.log(e);
    }
  }, [props.rules]);

  return (
    <Card className="shadow-sm widget-card">
      <div className="widget-header p-3 text-left">
        <span>
          <AiOutlinePieChart className="widget-header-icon mr-2" /> Sampling {samplePercent}%
        </span>
      </div>
        <Card.Body>
          <Row>
            <Col className="d-flex flex-column justify-content-center">
              <div className="sample-radial-chart-container">
                <AutoSizer>
                  {({height, width}) => 
                    (<RadialChart 
                      animation
                      width={width}
                      height={height}
                      data={data}
                      colorType="literal"
                    />)
                  }
                </AutoSizer>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex flex-column pt-5 justify-content-center">
              <div className="d-inline-block">
                { data.map((item, index) => (
                  <div key={index} className="d-inline-block mr-3">
                    <BsCircleFill color={item.color} className="mr-1" />
                    { item.labelText }
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Card.Body>
    </Card>
  );
}

export default FormVisPanel;